var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewLastInvoiceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 69.5197,
    height: 69.5197,
    rx: 5,
    fill: "#EDF2FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.1026 21H26.8718C25.2857 21 24 22.2686 24 23.8334V44.7498C24 46.8562 26.2466 48.2261 28.1561 47.2841L28.4593 47.1346C29.2678 46.7357 30.2194 46.7357 31.0279 47.1346L34.2029 48.7009C35.0114 49.0997 35.963 49.0997 36.7715 48.7009L39.9465 47.1346C40.755 46.7357 41.7066 46.7357 42.5151 47.1346L42.8183 47.2841C44.7277 48.2261 46.9744 46.8562 46.9744 44.7498V23.8334C46.9744 22.2686 45.6886 21 44.1026 21Z",
    fill: "#C3D2FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7949 32.3338H31.1795M26.8718 21H44.1026C45.6886 21 46.9744 22.2686 46.9744 23.8334V44.7498C46.9744 46.8562 44.7277 48.2261 42.8183 47.2841L42.5151 47.1346C41.7066 46.7357 40.755 46.7357 39.9465 47.1346L36.7715 48.7009C35.963 49.0997 35.0114 49.0997 34.2029 48.7009L31.0279 47.1346C30.2194 46.7357 29.2678 46.7357 28.4593 47.1346L28.1561 47.2841C26.2466 48.2261 24 46.8562 24 44.7498V23.8334C24 22.2686 25.2857 21 26.8718 21Z",
    stroke: "#2828F0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewLastInvoiceIcon);
export default __webpack_public_path__ + "static/media/newLastInvoiceIcon.ba34452c7e95e019d4d00dd526501b1f.svg";
export { ForwardRef as ReactComponent };